import Banner from "./Bannner";
import { Link } from "react-router-dom";
import ContactFooter from "./ContactFooter";
import glv from "../utils/getLocalizedValue"
import React from "react";
import TechnologyLiquidIQSection from "./TechnologyLiquidIQSection";

const publicUrl = process.env.PUBLIC_URL || "";

function IMMC() {
  return (
    <>
      <div
        className="flex-grow overflow-y-scroll overflow-x-hidden font-pretendard"
        style={{ scrollSnapType: "y mandatory" }}
      >
        <Banner
          title={glv(
            "About IMMC<span class='text-brand-kool-blue'>™</span>",
            "IMMC<span class='text-brand-kool-blue'>™</span> 기술 소개"
          )}
          src={require("../assets/banner/news-banner.jpg")}
        />
        <div className="flex flex-col sm:mx-auto mx-0 mt-[7rem] sm:max-w-[60rem] w-full px-5">
          <div className="text-center f-32 font-black">
            <div className="mb-10">{glv("Key Features", "주요 특징")}</div>
          </div>
          {glv(
            <div className="w-full flex text-center f-32 font-black border-b border-t justify-center border-black py-10">
              <div className="flex w-full items-start justify-center">
                <img
                  src={`${publicUrl}/svg/rocket.svg`}
                  alt=""
                  className="w-auto sm:h-[20rem] object-contain"
                />
              </div>
              <div className="flex w-full items-start justify-center">
                <img
                  src={`${publicUrl}/svg/bulb.svg`}
                  alt=""
                  className="w-auto sm:h-[19rem] object-contain"
                />
              </div>
              <div className="flex w-full items-start justify-center">
                <img
                  src={`${publicUrl}/svg/co2.svg`}
                  alt=""
                  className="w-auto sm:h-[17.5rem] object-contain"
                />
              </div>
            </div>,
            <div className="w-full flex text-center f-32 font-black border-b border-t justify-center border-black py-10">
              <div className="flex w-full items-start justify-center">
                <img
                  src={`${publicUrl}/svg/rocket-ko.svg`}
                  alt=""
                  className="w-auto sm:h-[20rem] object-contain"
                />
              </div>
              <div className="flex w-full items-start justify-center">
                <img
                  src={`${publicUrl}/svg/bulb-ko.svg`}
                  alt=""
                  className="w-auto sm:h-[19rem] object-contain"
                />
              </div>
              <div className="flex w-full items-start justify-center">
                <img
                  src={`${publicUrl}/svg/co2-ko.svg`}
                  alt=""
                  className="w-auto sm:h-[17.5rem] object-contain"
                />
              </div>
            </div>
          )}
        </div>
        <div className="max-w-[60rem] font-pretendard f-20 font-[300] mt-[7rem] mb-[3rem] px-5 text-justify ms-auto me-auto">
          <div className="font-black f-32 text-center mb-5">
            {glv(
              "What is an Integrated Manifold MicroChannel (IMMC)?",
              "Integrated Manifold MicroChannel (IMMC) 기술이란?"
            )}
          </div>
          <div className="my-10 w-full flex justify-center items-center">
            <img
              src={`${publicUrl}/svg/top.svg`}
              alt=""
              className="w-[20rem] sm:w-[25rem] object-contain"
            />
          </div>
          <br />
          {glv(
            <span>
              The performance of your semiconductors is directly tied to how
              effectively they are cooled. Lower temperatures not only ensure
              proper operation but also enable faster performance without the
              risk of thermal throttling.
              <br />
              <br /> KoolMicro’s groundbreaking Integrated Manifold MicroChannel
              (IMMC) technology provides cooling solutions up to eight times
              more effective than conventional methods, making it ideal for
              managing high-power-density semiconductors.
              <br />
              <br /> With its innovative manifold microchannel design, advanced
              chip integration, and optimized flow control, IMMC delivers
              uniform cooling across larger areas with reduced pumping power—all
              at a competitive cost. Backed by key patents and a team of
              seasoned engineers, KoolMicro offers tailored thermal solutions
              for high-performance data centers, automotive systems,
              semiconductors, and advanced packaging needs.
            </span>,
            <span>
              반도체의 성능은 얼마나 효과적으로 냉각하느냐에 달려 있습니다.{" "}
              <br />
              온도를 낮추면 반도체가 제 성능을 발휘할 수 있을 뿐 아니라 과열
              방지 때문에 성능 저하를 할 필요없이 더욱 빠르게 동작할 수
              있습니다. <br />
              <br /> KoolMicro의 혁신적인 IMMC(Integrated Maniford MicroChannel)
              기술은 고전력 고집적 반도체를 기존 방식보다 최대 8배 이상 더
              효율적으로 냉각할 수 있습니다.
              <br /> IMMC 기술의 독창적인 구조, 칩 집적 방식, 그리고 유동 제어
              기술은 합리적인 비용과 낮은 펌핑 전력으로 더 넓은 영역을 균일하게
              냉각할 수 있게 합니다.
              <br />
              <br /> KoolMicro는 다량의 주요 특허 기술과 풍부한 경험을 갖춘
              엔지니어 팀을 바탕으로 데이터센터, 자동차 시스템, 반도체 및 첨단
              패키징 등 필요한 분야에 알맞는 맞춤형 열 관리 솔루션을 제공합니다.
            </span>
          )}
        </div>
        <div className="flex flex-col mx-auto mt-[7rem] sm:max-w-[60rem] w-full px-5">
          <div className="text-center f-32 font-black border-b border-black">
            <div className="mb-10">
              {glv("Innovations of IMMC", "IMMC를 통한 혁신")}
            </div>
          </div>
          <div className="py-8 flex">
            <div className="flex min-w-[6rem] max-w-[6rem] sm:py-10 items-center">
              <div className="flex w-full h-full items-start">
                <img
                  alt=""
                  src={require("../assets/icon/cooling.png")}
                  className="object-contain"
                />
              </div>
            </div>
            <div className="flex min-w-1 max-w-1 sm:mx-[5rem] mx-5 rounded-full bg-brand-thermal-grey"></div>
            <div className="flex flex-col flex-grow">
              <div className="f-32 font-[700] mb-5 text-brand-darker-blue">
                {glv("Top-Notch Cooling", "최고 수준의 냉각 성능")}
              </div>
              <div className="f-20">
                {glv(
                  "Featuring a groundbreaking liquid cooling system, the IMMC provides superior cooling performance. This advanced technology ensures GPUs operate efficiently without overheating, supporting high performance for demanding tasks such as Al and Large Language Models (LLMs).",
                  "혁신적인 액체 냉각 시스템을 갖춘 IMMC 기술은 업계 최고 수준의 뛰어난 냉각 성능을 제공합니다. 이는 GPU가 과열 없이 효율적으로 작동할 수 있도록 보장하며, AI와 대규모 언어 모델(LLM)과 같은 고성능 작업을 안정적으로 지원합니다."
                )}
              </div>
            </div>
          </div>
          <div className="py-8 flex">
            <div className="flex min-w-[6rem] max-w-[6rem] sm:py-10 items-center">
              <div className="flex w-full h-full items-start">
                <img
                  alt=""
                  src={require("../assets/icon/compact.png")}
                  className="object-contain"
                />
              </div>
            </div>
            <div className="flex min-w-1 max-w-1 sm:mx-[5rem] mx-5 rounded-full bg-brand-thermal-grey"></div>
            <div className="flex flex-col flex-grow">
              <div className="f-32 font-[700] mb-5 text-brand-darker-blue">
                {glv("Compact Size", "작고 효율적인 크기")}
              </div>
              <div className="f-20">
                {glv(
                  "The IMMC's slim design saves space, allowing for more GPUs to fit in a server rack. Its compact size is ideal for crowded server rooms, optimizing the use of available space for advanced computing hardware.",
                  "IMMC 기술의 슬림한 디자인은 냉각 시스템이 차지하는 공간을 최소화하여 서버 랙에 더 많은 GPU를 장착 가능하게 합니다. 컴팩트한 크기는 대규모로 밀집된 서버 룸에 매우 적합하며, 고급 컴퓨팅 하드웨어를 위한 가용 공간을 최적화할 수 있습니다."
                )}
              </div>
            </div>
          </div>
          <div className="py-8 flex">
            <div className="flex min-w-[6rem] max-w-[6rem] sm:py-10 items-center">
              <div className="flex w-full h-full items-start">
                <img
                  alt=""
                  src={require("../assets/icon/eco.png")}
                  className="object-contain"
                />
              </div>
            </div>
            <div className="flex min-w-1 max-w-1 sm:mx-[5rem] mx-5 rounded-full bg-brand-thermal-grey"></div>
            <div className="flex flex-col flex-grow">
              <div className="f-32 font-[700] mb-5 text-brand-darker-blue">
                {glv("Eco-Friendly", "친환경 설계")}
              </div>
              <div className="f-20">
                {glv(
                  "IMMC employs a closed-loop water cooling system that reduces carbon emissions and water consumption. This approach lowers CO₂ emissions by 50% compared to standard air-cooled systems and minimizes water use, making it an environmentally friendly choice for data centers.",
                  "IMMC 기술은 탄소 배출과 물 소비를 줄이는 폐쇄형 수냉 시스템을 사용합니다. 이 방식은 기준 공랭 시스템에 비해 CO₂ 배출을 50% 적게 하고 물 사용량을 최소화하여친환경적인 초고성능 데이터 센터 구현이 가능합니다."
                )}
              </div>
            </div>
          </div>
          <div className="text-center f-32 font-black border-b border-black my-5"></div>
        </div>

        <div className="flex flex-col mx-auto mt-[7rem] sm:max-w-[60rem] w-full px-5">
          <div className="text-center f-32 font-black">
            <div className="">{glv("Technical Details", "기술 세부사항")}</div>
          </div>
          <div className="mt-10 w-full">
            <div className="flex f-32 font-black w-full items-center">
              <div className="flex ">
                {glv("Engineering", "공학 설계 방식")}
              </div>
              <div className="flex flex-grow h-[2px] ms-1 sm:ms-5 mt-1 bg-gray-500" />
            </div>
            <div className="f-20 font-[900] text-brand-darker-blue mt-10">
              {glv(
                "Manifold-Microchannel Liquid Cooling Method",
                "매니폴드-마이크로채널 수냉 방식"
              )}
            </div>
            <div className="f-20 mt-5">
              {glv(
                "IMMC employs high thermal conductive copper microchannels and an intelligent fluid-distribution manifold to deliver exceptional cooling, achieving 1,000W/cm². This innovative system uses water for cooling, effectively managing hotspots and maintaining uniform temperatures across dense server regions. It reduces CO₂ emissions by 50% compared to standard air cooling, benefiting the environment and conserving energy.",
                "IMMC 기술은 열 전도성이 높은 구리 마이크로채널과 지능형 유체 분배 매니폴드를 적용하여 최대 1,000W/cm²에 달하는 뛰어난 냉각 성능을 제공합니다. 이 시스템은 수냉식 구조를 통해 발열 지점을 효과적으로 제어하고, 밀집된 서버 지역의 전반적인 온도를 균일하게 유지합니다. 또한, 기존 공냉 시스템에 비해 CO₂ 배출량을 50% 줄여 환경보호와 에너지 절약에 기여합니다."
              )}
            </div>
            <div className="f-20 font-[900] text-brand-darker-blue mt-10">
              {glv("Liquid Flow", "개선된 액체 흐름 방식")}
            </div>
            <div className="f-20 mt-5">
              {glv(
                "Instead of just making parts thinner, we improve water flow in tiny channels. Our special manifold cuts these channels into short bits, fixing common issues like pressure drops and vapor backflow. This smart structure and multi-channel flow control design improves efficiency of heat removal and uniformity of temperature within the chip.",
                "단순히 부품을 더 얇게 만드는 데 그치지 않고 저희는 마이크로채널 내 액체 흐름을 개선하는 방식을 연구했습니다. IMMC 기술의 특수 매니폴드 구조는 마이크로채널을 짧게 분할해 압력 손실이나 증기 역류와 같이 빈번히 나타나는 문제를 해결했습니다. 이러한 스마트한 구조와 다채널 흐름 제어 설계는 칩 내부의 열 제거 효율과 칩 내 온도의 균일성을 대폭 개선했습니다."
              )}
            </div>
            <div className="w-full flex items-center justify-center">
              <div className="mt-10 w-[50%] flex items-center justify-center">
                {glv(
                  <img
                    src={require("../assets/tech/2.png")}
                    alt=""
                    className="object-cover w-full"
                  />,
                  <img
                    src={require("../assets/tech/2-ko.png")}
                    alt=""
                    className="object-cover w-full"
                  />
                )}
              </div>
            </div>
          </div>
          <div className="mt-10 w-full">
            <div className="flex f-32 font-black w-full items-center">
              <div className="flex ">{glv("Benefit", "IMMC의 장점")}</div>
              <div className="flex flex-grow h-[2px] ms-1 sm:ms-5 mt-1 bg-gray-500" />
            </div>
            <div className="f-20 font-[900] text-brand-darker-blue mt-10">
              {glv(
                "Superior Cooling with Small Form Factor",
                "작은 크기에 담긴 뛰어난 냉각 성능"
              )}
            </div>
            <div className="f-20 mt-5">
              {glv(
                "IMMC provides a robust, efficient, and environmentally friendly solution for modern high-performance computing needs. Combining smart design, premium materials, and intelligent monitoring, it is an ideal choice for operating sustainable data centers.",
                "IMMC 기술은 현대의 고성능 컴퓨팅 요구를 충족시키는 강력하고 효율적인 솔루션이면서 동시에 친환경적입니다. 스마트한 설계, 고급 소재, 그리고 지능형 모니터링은 지속 가능한 데이터 센터를 위한 최적의 옵션입니다."
              )}
            </div>
            <div className="f-20 font-[900] text-brand-darker-blue mt-10">
              {glv(
                "More Computing with Less Power",
                "적은 전력, 더 강력한 성능"
              )}
            </div>
            <div className="f-20 mt-5">
              {glv(
                "IMMC helps chip makers achieve higher performance with lower energy consumption. It allows users to maintain optimal chip performance during heavy-use scenarios while saving energy by reducing leakage power. Additionally, the lower operating temperature enhances device reliability and extends its life time.",
                "IMMC 기술은 에너지 소모를 줄이면서도 칩의 성능을 극대화합니다. 과부하인 상황에서도 최적의 칩 성능을 유지하며 낭비되는 전력을 최소화해 전력 효율을 높입니다. 또한 낮은 작동 온도로 장치의 안정성과 수명을 연장시키고 더 오래 지속되는 고성능 컴퓨팅 환경을 제공합니다."
              )}
            </div>
          </div>
        </div>

        <div className="mt-16 pt-10 flex items-center justify-center flex-col mx-auto sm:max-w-[60rem] w-full px-5">
          <div className="w-full">
            {glv(
              <img
                src={`${publicUrl}/svg/tech/thermal-graph.svg`}
                alt=""
                className="object-contain w-full"
              />,
              <img
                src={`${publicUrl}/svg/tech/thermal-graph-ko.svg`}
                alt=""
                className="object-contain w-full"
              />
            )}
          </div>
        </div>

        <div className="flex flex-col mx-auto mt-[7rem] sm:max-w-[60rem] w-full px-5">
          <div className="text-center f-32 font-black">
            <div className="">
              {glv("Product Applications", "IMMC 기술 적용 제품 소개")}
            </div>
            <div className="w-full mt-10">
              <img
                src={"/svg/tech/immc.svg"}
                alt=""
                className="w-full px-10 object-contain"
              />
            </div>
            <div className="mx-auto font-pretendard">
              <div className="text-center sm:text-6xl text-3xl font-[900]">
                1,000W/cm²
              </div>
              <div className="text-center sm:text-3xl text-xl font-[400] mt-5">
                {glv(
                  "Outstanding Cooling Capability",
                  "비교 불가능한 냉각 성능."
                )}
              </div>
            </div>
            <div className="w-full mt-[7rem]">
              <img
                src={require("../assets/side.png")}
                alt=""
                className="w-full px-10 object-contain"
              />
            </div>

            {glv(
              <div className="mt-[8rem] flex sm:w-[80%] mx-auto items-center justify-center">
                <div className="flex w-full justify-center">
                  <img
                    src={`${publicUrl}/svg/thermal.svg`}
                    alt=""
                    className="flex w-full object-contain"
                  />
                </div>
                <div className="flex w-full justify-center">
                  <img
                    src={`${publicUrl}/svg/cooling.svg`}
                    alt=""
                    className="flex w-full object-contain"
                  />
                </div>
                <div className="flex w-full justify-center">
                  <img
                    src={`${publicUrl}/svg/computing.svg`}
                    alt=""
                    className="flex w-full object-contain"
                  />
                </div>
              </div>,
              <div className="mt-[8rem] flex sm:w-[80%] mx-auto items-center justify-center">
                <div className="flex h-full justify-center">
                  <img
                    src={`${publicUrl}/svg/thermal-ko.svg`}
                    alt=""
                    className="flex h-full object-contain"
                  />
                </div>
                <div className="flex h-full justify-center">
                  <img
                    src={`${publicUrl}/svg/cooling-ko.svg`}
                    alt=""
                    className="flex h-full object-contain"
                  />
                </div>
                <div className="flex h-full justify-center">
                  <img
                    src={`${publicUrl}/svg/computing-ko.svg`}
                    alt=""
                    className="flex h-full object-contain"
                  />
                </div>
              </div>
            )}

            <div className="flex flex-col mx-auto mt-[12rem] sm:max-w-[60rem] w-full px-5">
              <div className="text-center f-32 font-black">
                <div className="">
                  {glv(
                    "IMMC vs. other cooling methods",
                    <span>
                      IMMC 성능 비교표
                      <br />
                      <span className="f-24 font-normal">
                        (vs. 타 상용 냉각 방식)
                      </span>
                    </span>
                  )}
                </div>
                <div className="w-full mt-10">
                  {glv(
                    <img
                      src={`${publicUrl}/svg/tech/table.svg`}
                      alt=""
                      className="w-full object-contain"
                    />,
                    <img
                      src={`${publicUrl}/svg/tech/table-ko.svg`}
                      alt=""
                      className="w-full object-contain"
                    />
                  )}
                </div>
              </div>
            </div>

            <div className="mt-[8rem] flex">
              <div className="flex w-full justify-center">
                <img
                  src={require("../assets/above.png")}
                  alt=""
                  className="flex w-[90%] object-contain"
                />
              </div>
              <div className="flex flex-col w-full justify-center">
                <div className="text-start font-[900] sm:text-3xl text-2xl">
                  {glv(
                    "Genuine Pocket Rocket",
                    <span>공간을 아끼는 미니멀한 크기</span>
                  )}
                </div>
                <div className="text-start font-[300] sm:text-lg text-sm mt-5">
                  {glv(
                    "The IMMC's slim design saves space, allowing for more GPUs to fit in a server rack. Its compact size is ideal for crowded server rooms, optimizing the use of available space for advanced computing hardware.",
                    "IMMC의 매우 얇은 두께는 차지하는 공간을 최소화하여 서버 랙에 더 많은 GPU를 탑재할 수 있게 합니다. 컴팩트한 크기는 복잡하게 밀집된 서버룸에 알맞게 설계되어 고성능 컴퓨팅 하드웨어의 공간을 더욱 효율적으로 활용할 수 있습니다."
                  )}
                </div>
              </div>
            </div>

            <div className="mt-[8rem] flex">
              <div className="flex flex-col w-full justify-center me-10">
                <div className="text-end font-[900] sm:text-3xl text-2xl">
                  {glv(
                    <span>
                      Patented IMMC
                      <span className="text-brand-electric-blue">™</span>{" "}
                      Structure
                    </span>,
                    <span>
                      특허받은 IMMC
                      <span className="text-brand-electric-blue">™</span> 기술
                    </span>
                  )}
                </div>
                <div className="text-end font-[300] sm:text-lg text-sm mt-5">
                  {glv(
                    "Featuring a groundbreaking liquid cooling system, the IMMC provides superior cooling performance. This advanced technology ensures GPUs operate efficiently without overheating, supporting high performance for demanding tasks such as Al and Large Language Models (LLMs).",
                    <span>
                      혁신적인 액체 냉각 시스템을 적용한 IMMC은
                      <br />
                      업계 최고 수준의 뛰어난 냉각 성능을 제공합니다.
                      <br />
                      GPU가 과열 없이 안정적으로 작동할 수 있도록 보장하며,
                      <br />
                      AI와 대규모 언어 모델(LLM) 같은 고성능 작업에서도 <br />
                      최고의 성능을 발휘할 수 있게 합니다.
                    </span>
                  )}
                </div>
              </div>
              <div className="flex w-full justify-center">
                <img
                  src={require("../assets/chip.png")}
                  alt=""
                  className="flex w-full object-cover object-left"
                />
              </div>
            </div>
          </div>
        </div>

        <TechnologyLiquidIQSection />

        <div className="flex flex-col w-full mt-[7rem] mb-[7rem]">
          <div className="text-center f-32 mb-10 font-black w-full">
            <div className="">{glv("Related Patents", "관련 특허")}</div>
          </div>
          <InfiniteLoopSlide />
        </div>

        <ContactFooter />
      </div>
    </>
  );
}

const Patent = () => {
  return (
    <div class="flex flex-row gap-4 mx-2">
      <img src={`${publicUrl}/png/patent/1.png`} alt="" class="3xl:h-[256px] xl:h-[150px] h-[100px]" />
      <img src={`${publicUrl}/png/patent/2.png`} alt="" class="3xl:h-[256px] xl:h-[150px] h-[100px]" />
      <img src={`${publicUrl}/png/patent/3.png`} alt="" class="3xl:h-[256px] xl:h-[150px] h-[100px]" />
      <img src={`${publicUrl}/png/patent/4.png`} alt="" class="3xl:h-[256px] xl:h-[150px] h-[100px]" />
      <img src={`${publicUrl}/png/patent/5.png`} alt="" class="3xl:h-[256px] xl:h-[150px] h-[100px]" />
    </div>

  );
}

const InfiniteLoopSlide = () => {
  return (
    <div className="slider-container overflow-hidden whitespace-nowrap relative">
      <div className="flex animate-scroll w-max">
        {[...Array(2)].flatMap((_, i) => (
          <React.Fragment key={i}>
            <Patent />
            <Patent />
            <Patent />
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default IMMC;
